import React, { useState, useEffect } from 'react';
import Navbar from '../../components/layout/Navbar';
import GlassCard from '../../components/ui/GlassCard';
import NeonButton from '../../components/ui/NeonButton';

const Shop = () => {
    const [user, setUser] = useState(null);
    const [items] = useState([
        { id: 1, name: 'Streak Freeze', price: 200, icon: '🧊', desc: 'Protect your streak for one day.' },
        { id: 2, name: 'Double XP Boost', price: 500, icon: '⚡', desc: 'Earn 2x XP for 30 minutes.' },
        { id: 3, name: 'Golden Frame', price: 1000, icon: '🖼️', desc: 'Shiny profile border.' },
        { id: 4, name: 'Neon Theme', price: 2500, icon: '🎨', desc: 'Unlock dark neon mode.' },
    ]);

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user') || 'null');
        setUser(userData);
    }, []);

    const handleBuy = (item) => {
        alert(`Request to buy ${item.name} for ${item.price} ZenCoins sent!`);
        // In real impl: POST /gamification/transaction
    };

    return (
        <div style={{ background: 'var(--bg-dark)', minHeight: '100vh', paddingBottom: '80px' }}>
            <Navbar />

            <div className="container" style={{ marginTop: '100px' }}>
                <header style={{ marginBottom: '40px', textAlign: 'center' }}>
                    <h1 className="text-gradient" style={{ fontSize: 'clamp(1.8rem, 5vw, 3rem)', marginBottom: '10px' }}>Zen Shop</h1>
                    <p style={{ color: '#94a3b8' }}>Spend your hard-earned ZenCoins on epic rewards.</p>
                </header>

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                        gap: '30px'
                    }}
                >
                    {items.map(item => (
                        <GlassCard key={item.id} hoverEffect={true} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <div style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', marginBottom: '20px' }}>{item.icon}</div>
                            <h3 style={{ color: 'white', marginBottom: '10px' }}>{item.name}</h3>
                            <p style={{ color: '#cbd5e1', marginBottom: '20px', fontSize: '0.9rem' }}>{item.desc}</p>
                            <div style={{ marginTop: 'auto' }}>
                                <div style={{ color: 'var(--accent)', fontWeight: 'bold', marginBottom: '15px' }}>
                                    💎 {item.price}
                                </div>
                                <NeonButton onClick={() => handleBuy(item)} style={{ width: '100%' }}>
                                    Buy Now
                                </NeonButton>
                            </div>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Shop;
